function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var AbstractPublisherTool = /*#__PURE__*/function () {
  function AbstractPublisherTool(sandbox, mapmodule) {
    var localization = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, AbstractPublisherTool);
    // override to change group (tool panel is created for each unique group)
    this.group = 'maptools';
    // index defines order in which the tools are listed on the group panel
    this.index = 0;
    // '*' means any, can be restricted to 'bottom left', 'bottom right' etc
    this.allowedLocations = ['*'];
    // List of plugin classes that can reside in same container like 'Oskari.mapframework.bundle.mapmodule.plugin.LogoPlugin'
    // '*' means no restrictions
    this.allowedSiblings = ['*'];
    // boilerplate
    this.__sandbox = sandbox;
    this.__mapmodule = mapmodule;
    this.__plugin = null;
    this.state = {
      // This variable is used to save tool state (is checked) and if it's true then we get tool json when saving published map.
      enabled: false,
      pluginConfig: null
    };
    this.__loc = localization[this.group];
  }
  return _createClass(AbstractPublisherTool, [{
    key: "init",
    value: function init(data) {
      var plugin = this.findPluginFromInitData(data);
      if (plugin) {
        this.storePluginConf(plugin.config);
        this.setEnabled(true);
      }
    }

    // override per tool
  }, {
    key: "getTool",
    value: function getTool() {
      return {
        id: 'N/A',
        title: 'N/A',
        config: this.state.pluginConfig || {}
      };
    }

    // override when the tool has a component / handler
  }, {
    key: "getComponent",
    value: function getComponent() {
      return {};
    }
  }, {
    key: "getTitle",
    value:
    // deprecated - new (React based) tools should use getTool().title instead
    function getTitle() {
      var toolTitle = this.getTool().title;
      if (!this.__loc) {
        return toolTitle;
      }
      return this.__loc[toolTitle];
    }
  }, {
    key: "getGroup",
    value: function getGroup() {
      return this.group;
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this.index;
    }
  }, {
    key: "findPluginFromInitData",
    value: function findPluginFromInitData(data) {
      var _data$configuration;
      var toolId = this.getTool().id;
      // assume it's in mapfull bundles plugins array as most of the default tools are stored there
      return data === null || data === void 0 || (_data$configuration = data.configuration) === null || _data$configuration === void 0 || (_data$configuration = _data$configuration.mapfull) === null || _data$configuration === void 0 || (_data$configuration = _data$configuration.conf) === null || _data$configuration === void 0 || (_data$configuration = _data$configuration.plugins) === null || _data$configuration === void 0 ? void 0 : _data$configuration.find(function (plugin) {
        return toolId === plugin.id;
      });
    }
  }, {
    key: "storePluginConf",
    value: function storePluginConf(conf) {
      this.state.pluginConfig = conf || {};
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      var tool = this.getTool();

      // state actually hasn't changed -> do nothing
      if (this.isEnabled() === enabled) {
        return false;
      }
      if (!enabled) {
        this.stop();
      } else if (tool.hasNoPlugin !== true) {
        var plugin = this.getPlugin();
        if (!plugin) {
          plugin = Oskari.clazz.create(tool.id, tool.config);
          this.__plugin = plugin;
        }
        this.getMapmodule().registerPlugin(plugin);
        plugin.startPlugin(this.getSandbox());
      }
      // Stop checks if we are already disabled so toggle the value after
      this.state.enabled = enabled;
      // notify publisher tool layout panel in case tool placement dragging needs to be toggled
      var event = Oskari.eventBuilder('Publisher2.ToolEnabledChangedEvent')(this);
      this.getSandbox().notifyAll(event);
      return true;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return !!this.state.enabled;
    }
  }, {
    key: "getValues",
    value: function getValues() {
      // override
      return null;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.isEnabled()) {
        return;
      }
      var tool = this.getTool();
      if (tool.hasNoPlugin !== true) {
        var plugin = this.getPlugin();
        if (!plugin) {
          return;
        }
        if (this.getSandbox()) {
          plugin.stopPlugin(this.getSandbox());
        }
        this.getMapmodule().unregisterPlugin(plugin);
        this.__plugin = null;
      }
    }

    /**
    * Is displayed. We can use this to tell when tool is displayed.
    * For example if stats layers are added to map when opening publisher we can tell at then this tool need to be shown (ShowStatsTableTool).
    * Is there is no stats layer then not show the tool.
    *
    * @method isDisplayed
    * @public
    *
    * @returns {Boolean} is tool displayed
    */
  }, {
    key: "isDisplayed",
    value: function isDisplayed() {
      return true;
    }

    /**
    * Is this tool available.
    * @method isDisabled
    * @public
    *
    * @returns {Boolean} is tool disabled
    */
  }, {
    key: "isDisabled",
    value: function isDisabled(data) {
      return false;
    }
  }, {
    key: "validate",
    value: function validate() {
      // always valid by default
      // could return false if there's something wrong that should require stopping the user from saving
      return true;
    }
  }, {
    key: "getPlugin",
    value: function getPlugin() {
      return this.__plugin;
    }
  }, {
    key: "getSandbox",
    value: function getSandbox() {
      return this.__sandbox;
    }
  }, {
    key: "getMapmodule",
    value: function getMapmodule() {
      return this.__mapmodule;
    }
  }, {
    key: "getAllowedLocations",
    value: function getAllowedLocations() {
      return this.allowedLocations;
    }

    // old tools return jQuery object that renders the extra options for this tool
  }, {
    key: "getExtraOptions",
    value: function getExtraOptions() {
      return null;
    }
  }]);
}();
;

/*
Make base class discoverable through Oskari.clazz.get('Oskari.publisher.AbstractPublisherTool');
NOTE! This might not work for bundles that are bundled _before_ the publisher bundle

Usage:

const AbstractPublisherTool = Oskari.clazz.get('Oskari.publisher.AbstractPublisherTool')
class MyTool extends AbstractPublisherTool {
    // TODO: impl specifics for tool
}

// Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.MyTool',
    MyTool,
    {
        'protocol': ['Oskari.mapframework.publisher.Tool']
    }
);
 */
Oskari.clazz.defineES('Oskari.publisher.AbstractPublisherTool', AbstractPublisherTool);